import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import testTargetSelector from 'selectors/testTarget/testTargetSelector';

const testTargetOffersSelector = createSelector(testTargetSelector, testTarget => testTarget.offers || Empty.Object);

export { testTargetOffersSelector };
